module.exports = __webpack_public_path__ + "img/197.fa170342.jpg";